<template>
    <div class="form-contact-import">

        <mu-paper :z-depth="1">

            <mu-form :model="form" enctype="multipart/form-data">
                <!-- Seleção de cliente caso for Ziad ou Revenda -->
                <mu-select label="Selecione o cliente *" filterable v-model="form.client_id" full-width v-if="isZiad()" @change="loadGroups()">
                    <mu-option v-for="(item, index) in options.clients" :key="`client_${index}`" :label="item.label" :value="item.id"></mu-option>
                </mu-select>

                <!-- Tipo Import -->
                <mu-form-item prop="radio" class="radio-bg">
                    <mu-radio v-model="form.group" value="new" label="Novo Grupo" @change="setTypeImport()"></mu-radio>
                    <mu-radio v-model="form.group" value="exist" label="Grupo Existente" @change="setTypeImport()"></mu-radio>
                </mu-form-item>

                <!-- Lista de grupos -->
                <mu-select label="Grupo" v-model="form.group_id" full-width v-if="form.group == 'exist'" @change="loadSubgroup()">
                    <mu-option v-for="(opcGroup, key) in groupList" :key="key" :label="opcGroup.name" :value="opcGroup.id"></mu-option>
                </mu-select>

                <mu-select label="Subgrupo" v-model="form.subgroup_id" full-width v-if="form.group == 'exist' && (options.subgroups && options.subgroups.length > 0)">
                    <mu-option v-for="(opcSub, index) in options.subgroups" :key="index" :label="opcSub.name" :value="opcSub.id"></mu-option>
                    <mu-option label="Nenhuma opção" value=""></mu-option>
                </mu-select>

                <!-- Nome do grupo -->
                <mu-text-field v-model="form.group_name" full-width label="Nome do grupo" v-if="form.group == 'new'" :max-length="50"></mu-text-field>

                <!-- Mensagem -->
                <mu-form-item prop="textarea" label="Descrição">
                    <mu-text-field multi-line :rows="6" :rows-max="6" v-model="form.description" :max-length="500"></mu-text-field>
                </mu-form-item>

                <div class="alert-info">
                    Acesse o <a href="http://manual.plataformadesms.com.br" target="_blank">Manual da Plataforma</a> para ver os formatos e exemplos de importação.
                </div>

                <br>

                <!-- Upload de arquivo -->
                <div class="upload" v-if="form.load_type == 'import'">
                    <div v-if="!form.file">
                        <input type="file" ref="file" class="input-file" @change="handleFileUpload">
                        <font-awesome-icon icon="upload" size="2x" />
                        <h3 class="title">Selecione ou arraste aqui o arquivo</h3>
                        <p>Formatos permitidos: XLSX ou CSV </p>
                    </div>
                    <div v-else class="description">
                        <font-awesome-icon icon="paperclip" size="2x" />
                        <p>O arquivo <strong>{{ form.file.name }}</strong> possui o tamanho de <strong>{{ form.file.size }}</strong> kbytes</p>
                        <mu-button @click="removeFile()" round color="red">Remover Arquivo</mu-button>
                    </div>
                </div>

                <!-- Salvar -->
                <mu-flex class="actions">
                    <mu-button round color="primary" @click="saveForm()" :disabled="!validateForm()">
                        <font-awesome-icon icon="check" class="icon-md icon-margin-left"/>
                        Importar
                    </mu-button>
                    <mu-button round :to="{ name: 'app.contacts.import' }">
                        Cancelar
                    </mu-button>
                </mu-flex>

            </mu-form>

        </mu-paper>

    </div>
</template>

<script>
    import GroupsServices from '@/services/contacts/groups'
    import ClientService from '@/services/settings/clients'
    import ImportServices from '@/services/contacts/import'

    export default {
        name: 'mu-form-contact',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                options: {
                    clients: [],
                    groups: [],
                    subgroups: []
                },
                form: {
                    group: 'new',
                    group_id: null,
                    group_name: null,
                    subgroup_id: null,
                    description: '',
                    load_type: 'import',
                    load_text: '',
                    file: ''
                }
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Pegamos os dados da empresa gravadas no STATE
             */
            companie () {
                return this.$store.state.company || null
            },

            // FILTRO DE GRUPO
            groupList () {
                return this.options.groups.filter((item) => {
                    return item.group_id === null
                })
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        async created () {
            await this.loadGroups()
            if (this.isZiad()) {
                await this.loadClients()
            }
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            loadSubgroup () {
                let result = this.options.groups.filter((item) => {
                    return item.id === this.form.group_id
                })
                this.options.subgroups = result[0].subGroups
            },

            /**
             * Carrega a lista de clientes que a revenda logada possui
             */
            async loadClients () {
                try {
                    this.$eventHub.$emit('loading', true, 'Carregando as informações necessárias.')

                    let result = await ClientService.all()

                    if (result && result.status) {
                        let arrayOptions = result.results.map((item) => {
                            return {
                                id: item.id,
                                label: item.nick_name
                            }
                        })
                        this.options.clients = [
                            { id: this.companie.id, label: this.companie.name },
                            ...arrayOptions
                        ]
                    }
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', 'Não foi possível carregar os clientes.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Carregando a lista de grupos caso precisar que a importação seja para determinado grupo
             */
            async loadGroups () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... carregando grupos.')
                    this.options.groups = []
                    this.options.subgroups = []
                    this.form.subgroup_id = ''
                    this.form.group_id = ''
                    let result
                    if (this.form.client_id) {
                        result = await GroupsServices.allByCompany(this.form.client_id)
                    } else {
                        result = await GroupsServices.all()
                    }
                    if (result && result.status) {
                        this.options.groups = result.results
                        return
                    }
                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os grupos.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Salva os dados para gerar uma importação
             */
            async saveForm () {
                try {
                    this.$eventHub.$emit('loading', true, 'Enviando arquivo para importação de contatos.')

                    if (this.form.subgroup_id) {
                        this.form.group_id = this.form.subgroup_id
                    }

                    let result = await ImportServices.store(this.form)

                    if (result && result.status === 400) {
                        for (const key in result.errors) {
                            if (result.errors.hasOwnProperty(key)) {
                                const element = result.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element[0], false)
                                return
                            }
                        }
                        return
                    } else if (result && result.status) {
                        this.$eventHub.$emit('snackbar', 'success', result.message)
                        this.$router.push({ name: 'app.contacts.import' }).catch(err => { if (err) console.log(err.name || '') })
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível importar os contatos.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            /**
             * Com o set type import zeramos algumas propriedades de acordo com o tipo de importação selecionada
             */
            setTypeImport (type) {
                if (this.form.group === 'new') {
                    this.form.group_id = null
                } else if (this.form.group === 'exist') {
                    this.form.group_name = null
                }
            },

            /**
             * Fazemos uma validação dos dados
             */
            validateForm () {
                if (this.form.group === 'new') {
                    if (!this.form.group_name) { return false }
                } else if (this.form.group === 'exist') {
                    if (!this.form.group_id) { return false }
                }
                if (!this.form.description) { return false }
                if (!this.form.file) { return false }
                return true
            },

            /**
             * Adiciona o arquivo e faz uma validação da extensão
             */
            handleFileUpload () {
                this.form.file = this.$refs.file.files[0]
                let extension = this.form.file.name.split('.').pop()
                let extensionsPossibles = ['XLSX', 'CSV']
                if (!extensionsPossibles.includes(extension.toUpperCase())) {
                    this.$eventHub.$emit('snackbar', 'error', `A extensão do arquivo não é permitido (.${extension.toUpperCase()}).`)
                    this.form.file = ''
                }
            },

            /**
             * Remove o arquivo
             */
            async removeFile (e) {
                this.form.file = ''
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../assets/stylus/bootstrap.styl'

    .form-contact-import

        .mu-alert
            font-size 12px
            padding 10px 15px
            margin-top 10px
            i
                color rgba(255, 255, 255, 0.6)

        .alert-info
            background $orange
            padding 15px
            border-radius 5px
            text-align center
            color #fff
            a
                text-decoration underline
                color #fff

        .mu-paper
            padding 20px

        .mu-button
            margin-right 10px

        .upload
            width 100%
            padding 20px
            background lighten($grey, 70%)
            border 1px $grey solid
            color darken($grey, 30%)
            text-align center
            position relative
            overflow hidden
            display inline-block
            border-radius 5px
            margin-bottom 20px

            &:hover
                background lighten($grey, 50%)

            .title
                margin 0

            p
                margin 0

            .description
                padding-top 20px

                span
                    padding 0 5px

            input[type='file']
                border 0
                width 100%
                z-index 200
                cursor pointer
                position absolute
                left 0
                top 0
                bottom 0
                opacity 0

        .radio-bg
            margin-bottom 0

</style>
